import { Loader } from './components';
import styles from './IconButton.module.scss';

export interface IconButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  testId: string;
  size?: number;
  variant?:
    | 'actionPrimary'
    | 'actionSecondary'
    | 'neutralSecondary'
    | 'negativeSecondary'
    | 'premiumPrimary'
    | 'premiumSecondary'
    | 'lightPrimary';
  shape?: 'square' | 'circle';
  disabled?: boolean;
  loading?: boolean;
  active?: boolean;
}

export const IconButton = ({
  testId,
  size = 500,
  variant = 'actionPrimary',
  shape = 'square',
  active = false,
  disabled,
  loading,
  children,
  ...props
}: IconButtonProps) => {
  return (
    <button
      {...props}
      className={`${styles.iconButton} ${props.className || ''}`}
      data-test-id={`${testId}-container`}
      data-size={size}
      data-variant={variant}
      data-shape={shape}
      data-active={active}
      data-disabled={disabled}
      data-loading={loading}
    >
      {!loading && children}
      {loading && (
        <Loader className={styles.loader} data-test-id={`${testId}-loader`} />
      )}
    </button>
  );
};
